import Image from "@tiptap/extension-image";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import ResizableImageTemplate from "./ResizableImageNodeView.vue";
import { getAlignmentStyle } from "../utils/ImageNodeHelper";

export const ResizableImage = Image.extend({
  name: "ResizableImage",

  addAttributes() {
    return {
      ...this.parent?.(),

      style: {
        default: null,
        parseHTML: (element) => getAlignmentStyle(element.getAttribute("style")),
        renderHTML: ({ style }) => ({ style }),
      },

      width: {
        default: null,
        renderHTML: ({ width }) => ({ width }),
      },
    };
  },

  addNodeView() {
    return VueNodeViewRenderer(ResizableImageTemplate);
  },
});

